/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Alert } from '../../models/alert';

export interface GetAlerts1$Params {
   /**
    * Date in format YYYY-MM-DD (inclusive).
    */
   date: string;

   /**
    * Provider id
    */
   providerId: string;

   /**
    * Alert type (temperature, precipitation, etc.)
    */
   type: number;
}

export function getAlerts1(
   http: HttpClient,
   rootUrl: string,
   params: GetAlerts1$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Alert>> {
   const rb = new RequestBuilder(rootUrl, getAlerts1.PATH, 'get');
   if (params) {
      rb.query('date', params.date, {});
      rb.query('providerId', params.providerId, {});
      rb.query('type', params.type, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Alert>;
      })
   );
}

getAlerts1.PATH = '/api/v1/weather/alert';
